import { getRatingTag } from '@helpers/rating';
import React from 'react';

type RatingTagProps = {
  rating: number;
  classes?: string;
  isSeoPage?: boolean;
  isSRP?: boolean;
};

const defaultProps = {
  classes: '',
  isSeoPage: false,
  isSRP: false,
};
function RatingTag({ classes, rating, isSeoPage, isSRP }: RatingTagProps) {
  // If need to add extra conditions here, consider using a "classes" prop instead.
  const baseStyle = () => {
    if (isSRP) {
      return 'text-sm text-custom-gray-4 d:text-custom-black';
    }

    if (isSeoPage) {
      return 'font-rp-pn-regular text-sm leading-4 text-custom-gray-4 pl-2';
    }

    return 'text-base text-custom-black';
  };

  return (
    <div
      data-testid="rating-tag"
      className={`${baseStyle()} font-medium -tracking-0.26 ${classes}`}
    >
      {getRatingTag(rating)}
    </div>
  );
}

RatingTag.defaultProps = defaultProps;

export default RatingTag;
